import { EROSION_BREAKS_M, EROSION_COLORMAP } from '~/constants'

type Rgba = readonly [number, number, number, number]

/** Pre-parsed once at module load; the colour function runs 65,536 times per tile. */
const EROSION_RGBA: readonly Rgba[] = EROSION_COLORMAP.map(({ hex, alpha }) => {
  const n = hex.replace('#', '')
  return [
    parseInt(n.slice(0, 2), 16),
    parseInt(n.slice(2, 4), 16),
    parseInt(n.slice(4, 6), 16),
    alpha,
  ] as const
})

/** Index into EROSION_RGBA for a signed bed-level change in metres. */
export function erosionClassIndex(change: number): number {
  for (let i = 0; i < EROSION_BREAKS_M.length; i++) {
    if (change < EROSION_BREAKS_M[i]!) return i
  }
  return EROSION_BREAKS_M.length
}

export function erosionRgba(change: number): Rgba {
  return EROSION_RGBA[erosionClassIndex(change)]!
}
